export enum ProductPricingDiscriminator {
    Absolute = 'Absolute',
    Relative = 'Relative',
}
